import React from "react";
import { UserInfo } from "../hooks/useUserInfo";
import { SectionCard, FieldDisplay, FieldList } from "../../../ui";

interface UserInfoViewProps {
  userInfo: UserInfo;
}

export function UserInfoView({ userInfo }: UserInfoViewProps) {
  return (
    <SectionCard title="User Information" showBorder={false}>
      <FieldList>
        <FieldDisplay label="Email" value={userInfo.email} />
        <FieldDisplay
          label="Organization"
          value={userInfo.organization}
          valueClassName="lowercase"
        />
        {userInfo.joinDate && (
          <FieldDisplay
            label="Member Since"
            value={new Date(userInfo.joinDate).toLocaleDateString()}
          />
        )}
      </FieldList>
    </SectionCard>
  );
}

